/** Hamssah public contact + legal identifiers (storefront, emails, CGV). */
export type HamssahContact = {
  legalName: string;
  displayName: string;
  addressLine1: string;
  city: string;
  country: string;
  email: string;
  ordersEmail: string;
  phone: string;
  phoneDisplay: string;
  whatsapp: string;
  ice: string;
  rc: string;
  deliverySlaDays: string;
  maxFulfillmentDays: number;
  withdrawalDays: number;
  refundDays: number;
};

export const HAMSSAH_CONTACT: HamssahContact = {
  legalName: 'Hamssah',
  displayName: 'Hamssah',
  addressLine1: 'Fès, Maroc',
  city: 'Fès',
  country: 'Maroc',
  email: 'contact@hamssah.com',
  ordersEmail: 'commandes@hamssah.com',
  phone: '+212600000000',
  phoneDisplay: '+212 6 00 00 00 00',
  whatsapp: '+212600000000',
  ice: '000000000000000',
  rc: 'RC Fès',
  deliverySlaDays: '2 à 5 jours ouvrés',
  maxFulfillmentDays: 30,
  withdrawalDays: 7,
  refundDays: 15,
};

/** Merge CMS site settings over compile-time defaults (storefront + legal pages). */
export function resolveHamssahContact(
  settings?: Partial<{
    legalName: string;
    displayName: string;
    addressLine1: string;
    city: string;
    country: string;
    email: string;
    ordersEmail: string;
    phone: string;
    phoneDisplay: string;
    whatsapp: string;
    ice: string;
    rc: string;
    deliverySlaDays: string;
    maxFulfillmentDays: number;
    withdrawalDays: number;
    refundDays: number;
  }> | null,
): HamssahContact {
  if (!settings) return { ...HAMSSAH_CONTACT };
  return {
    legalName: settings.legalName?.trim() || HAMSSAH_CONTACT.legalName,
    displayName: settings.displayName?.trim() || HAMSSAH_CONTACT.displayName,
    addressLine1: settings.addressLine1?.trim() || HAMSSAH_CONTACT.addressLine1,
    city: settings.city?.trim() || HAMSSAH_CONTACT.city,
    country: settings.country?.trim() || HAMSSAH_CONTACT.country,
    email: settings.email?.trim() || HAMSSAH_CONTACT.email,
    ordersEmail: settings.ordersEmail?.trim() || HAMSSAH_CONTACT.ordersEmail,
    phone: settings.phone?.trim() || HAMSSAH_CONTACT.phone,
    phoneDisplay: settings.phoneDisplay?.trim() || HAMSSAH_CONTACT.phoneDisplay,
    whatsapp: settings.whatsapp?.trim() || HAMSSAH_CONTACT.whatsapp,
    ice: settings.ice?.trim() || HAMSSAH_CONTACT.ice,
    rc: settings.rc?.trim() || HAMSSAH_CONTACT.rc,
    deliverySlaDays: settings.deliverySlaDays?.trim() || HAMSSAH_CONTACT.deliverySlaDays,
    maxFulfillmentDays: settings.maxFulfillmentDays ?? HAMSSAH_CONTACT.maxFulfillmentDays,
    withdrawalDays: settings.withdrawalDays ?? HAMSSAH_CONTACT.withdrawalDays,
    refundDays: settings.refundDays ?? HAMSSAH_CONTACT.refundDays,
  };
}
